export default __webpack_public_path__ + "static/table-52130de3171b92ca809ba1de5c1ccee4.png";